import { ACTIONS } from '../actions';

const INITIAL_STATE = {
    total_private_link : 0,
    total_click: 0
};

export default function (state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.PRIVATE_SUMMARY:
            if(!action.payload.data) {
                return state;
            }
            return { ...state, total_private_link: action.payload.data.total_private_link, total_click: action.payload.data.total_click };
        default:
            return state;
    }
}